import { PRIMARY_USD_ASSET } from './tradingConstants'

/** `V3QuoteAssetService.getLastQuoteAsset/setLastQuoteAsset` — the coin
 * list's quote-asset filter survives page changes within the browser tab
 * (legacy `sessionStorage['lastQuoteAsset']`; `'-'` means "any coin pair"). */
const KEY = 'lastQuoteAsset'

export function getLastQuoteAsset(anyValueEnabled = true): string {
  let value: string
  try {
    value = sessionStorage.getItem(KEY) || ''
  } catch {
    value = ''
  }
  if (!value) return PRIMARY_USD_ASSET
  if (!anyValueEnabled && value === '-') return PRIMARY_USD_ASSET
  return value
}

export function setLastQuoteAsset(coin2: string) {
  try {
    sessionStorage.setItem(KEY, coin2)
  } catch {
    /* storage unavailable — the filter just is not remembered */
  }
}
